// Mock data for Pedro & Josefa Consultores

export const siteConfig = {
  name: "P&J Consultores",
  tagline: "Tecnología Experta, Cercanía Vecinal",
  location: "Santo Domingo, Chile",
  email: "contacto@pjconsultores.cl",
  phone: "+56 9 9076 5295",
};

export const navigation = [
  { name: "Inicio", href: "/" },
  { name: "Soluciones Hogar", href: "/soluciones-hogar" },
  { name: "Desarrollo Web", href: "/desarrollo-web" },
  // { name: "Soluciones Empresas", href: "/soluciones-empresas" },
  { name: "Quiénes Somos", href: "/quienes-somos" },
  { name: "Contacto", href: "/contacto" },
];

export const heroContent = {
  title:
    "Tecnología Experta: Tus vecinos en Santo Domingo, Consultores para todo Chile.",
  subtitle:
    "Somos una consultora tecnológica familiar. Llevamos conectividad satelital y mantención de equipos a tu hogar en la costa, y potenciamos tu marca con soluciones digitales a medida.",
};

export const serviceCards = {
  local: {
    icon: "Wifi",
    title: "¿Vives en Santo Domingo?",
    description: "Instalación Starlink, Soporte PC y Smart Home.",
    cta: "Ver Servicios Hogar",
    href: "/soluciones-hogar",
  },
  business: {
    icon: "BarChart3",
    title: "¿Buscas Innovación B2B?",
    description: "Data Science, BI y Desarrollo de Software a medida.",
    cta: "Ver Servicios Empresas",
    href: "/soluciones-empresas",
  },
  webDev: {
    icon: "Globe",
    title: "Desarrollo Web & Apps",
    description: "Sitios web, E-Commerce y Aplicaciones a medida.",
    cta: "Ver Desarrollo Web",
    href: "/desarrollo-web",
  },
};

export const techStack = [
  "Python",
  "React",
  "NestJS",
  "Google Cloud",
  "SQL",
  "TensorFlow",
  "Power BI",
  "Docker",
  "TypeScript",
  "NextJS",
  "TailwindCSS",
];

export const team = [
  {
    name: "Pedro",
    role: "Ingeniero Informático & Diseñador UX/UI",
    expertise: "Experto en Hardware, Arquitectura de Software y Diseño UX/UI.",
    image: null,
  },
  {
    name: "Josefa",
    role: "Data Scientist & Gerente de Datos",
    expertise: "Experta en Modelos Predictivos y Estrategia de Negocios.",
    image: null,
  },
];

export const homeServices = [
  {
    icon: "Satellite",
    title: "Instalación Starlink",
    description:
      "Conexión satelital de alta velocidad para tu hogar en la costa. Olvídate de las BAM lentas y los cortes de señal.",
  },
  {
    icon: "Monitor",
    title: "Soporte y Mantención Hardware",
    description:
      "Mantención, reparación y optimización de computadores. Especialistas en Windows/PC.",
    highlight: true,
  },
  {
    icon: "Home",
    title: "Smart Home",
    description:
      "Automatización del hogar, cámaras de seguridad y dispositivos inteligentes.",
  },
];

export const businessServices = [
  {
    icon: "Brain",
    title: "Data Science & Analytics",
    description:
      "Modelos predictivos, análisis de datos y machine learning para decisiones basadas en evidencia.",
    caseStudy: "Reducción del 30% en costos de generación de datos.",
  },
  {
    icon: "LineChart",
    title: "Business Intelligence",
    description:
      "Dashboards interactivos, reportes automatizados y visualización de KPIs en tiempo real.",
  },
  {
    icon: "Code2",
    title: "Desarrollo de Software",
    description: "Aplicaciones web a medida, APIs y sistemas empresariales.",
    caseStudy: "E-commerce con SEO orgánico y posicionamiento de marca.",
  },
];

export const aboutStory = {
  title: "Nuestra Historia",
  content:
    "Cambiamos el ritmo de Santiago por la calidad de vida de Santo Domingo. Nos complementamos: Josefa analiza el futuro con datos, Pedro construye la infraestructura digital.",
  values: [
    {
      title: "Excelencia Técnica",
      description: "Estándares de ingeniería de clase mundial.",
    },
    {
      title: "Cercanía",
      description: "Somos tus vecinos, nos importa tu éxito.",
    },
    {
      title: "Transparencia",
      description: "Comunicación clara y honesta siempre.",
    },
  ],
};

export const testimonials = [
  {
    name: "María González",
    location: "Santo Domingo",
    text: "Por fin tengo internet estable en mi casa de playa. El servicio de instalación fue impecable.",
  },
  {
    name: "Empresa Logística SpA",
    location: "Santiago",
    text: "El modelo predictivo que desarrollaron nos ayudó a reducir costos significativamente.",
  },
];

export const webSuccessCases = [
  {
    title: "Comercial Teba",
    category: "E-Commerce Mayorista",
    description:
      "Plataforma B2B para distribuidora mayorista con sistema de gestión de pedidos y catálogo en línea.",
    image: "/assets/works/comercialteba.webp",
    tags: ["Vite", "CMS", "E-Commerce"],
    link: "https://www.comercialteba.cl/",
  },
  {
    title: "Presupuestados",
    category: "App Finanzas Personales",
    description:
      "Aplicación web para seguimiento de gastos en pareja, integración con IA para lectura de estados de cuenta y asistente RAG.",
    image: "/assets/works/presupuestados.webp",
    tags: ["React", "IA", "Finanzas"],
    link: "http://presupuestados.cl/",
  },
  {
    title: "A Tiempo",
    category: "E-Commerce Pyme",
    description:
      "Tienda online de cajas de mercadería con integración de pasarela de pago Flow y gestión de inventario.",
    image: "/assets/works/atiempo.webp",
    tags: ["E-Commerce", "Flow", "Pyme"],
    link: "https://cajasdemercaderiaatiempo.cl/",
  },
];
